/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState } from "react";
import moment from "moment";
import {
  Table,
  TableRow,
  TableBody,
  Icon,
  TableCell,
  TableContainer,
  Checkbox,
  Chip,
} from "@material-ui/core";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import Read from "../../Assets/Svg/view.svg";
import Edit from "../../Assets/Svg/edit.svg";
import Delete from "../../Assets/Svg/delete.svg";
import CancelIcon from '@material-ui/icons/Cancel';
import CircularProgress from '@material-ui/core/CircularProgress';
import { tableStyles } from "./tableStyles";
import Pagination from "./Components/Pagination";
import Switch from "./Components/Switch";
import TableHeader from "./Components/TableHeader";
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import PauseIcon from '@material-ui/icons/Pause';
import { toast } from "react-toastify";
import { UNAUTHORIZED_ACCESS } from "config/common";

function MainTable({
  USERLIST,
  TABLE_HEAD,
  handleNextPage,
  handlePreviousPage,
  page = 1,
  setPage,
  noPagination,
  loading,
  data,
  pageInfo,
  cancelingAirdropId = null,
  enableSelection = false,
  selectedRows = [],
  onSelectionChange,
  rowsPerPage = 10,
  returnRowOnSelection = false,
  error,
  jumpToPage,
}) {
  const classes = tableStyles();
  const columnSpan = TABLE_HEAD?.length + (enableSelection ? 1 : 0);
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  const isTrue = USERLIST?.length % rowsPerPage === 0;
  const maxPage = isTrue
    ? parseInt(USERLIST?.length / rowsPerPage, 10)
    : parseInt(USERLIST?.length / rowsPerPage, 10) + 1;

  const formatHash = (hash) => {
    if (hash === "N/A") {
      return hash;
    }
    return hash?.slice(0, 7) + "..." + hash?.slice(-5);
  };

  const getWalletValue = (rowData) => {
    const wallet = rowData?.wallet || rowData?.walletAddress;
    return wallet && wallet !== "N/A" ? wallet : "";
  };

  const getTransactionHash = (rowData) => {
    const hash =
      rowData?.gift?.token?.transactionHash ||
      rowData?.token?.transactionHash ||
      rowData?.txnHash ||
      rowData?.transactionHash;

    return hash && hash !== "N/A" ? hash : "";
  };

  const getTransactionUrl = (hash) =>
    hash ? `https://sepolia.basescan.org/tx/${hash}` : undefined;

  const copyTextToClipboard = async (value, successMessage) => {
    if (!value || typeof navigator === "undefined" || !navigator.clipboard?.writeText) {
      return;
    }

    try {
      await navigator.clipboard.writeText(value);
      if (successMessage) {
        toast.success(successMessage);
      }
    } catch {
      toast.error("Unable to copy to clipboard");
    }
  };

  const formatCellValue = (cellValue, fieldId) => {
    const pointFields = ["points", "eventPoints", "questPoints"];

    if (
      pointFields.includes(fieldId) &&
      cellValue !== null &&
      cellValue !== undefined &&
      cellValue !== "" &&
      !Number.isNaN(Number(cellValue))
    ) {
      return Number(cellValue).toFixed(4);
    }

    if (typeof cellValue === "number") {
      return Number.isInteger(cellValue) ? cellValue : cellValue.toFixed(2);
    }

    return cellValue ? cellValue : "N/A";
  };

  // NEW: Selection handlers
  const handleRowSelection = (rowId) => {
    if (!enableSelection || !onSelectionChange) return;

    let newSelection;
    if (selectedRows.includes(rowId)) {
      newSelection = selectedRows.filter(id => id !== rowId);
    } else {
      newSelection = [...selectedRows, rowId];
    }
    onSelectionChange(newSelection);
  };

  const handleSelectAll = () => {
    if (!enableSelection || !onSelectionChange) return;

    if (selectedRows.length === USERLIST.length) {
      onSelectionChange([]);
    } else {
      if (returnRowOnSelection) {
        onSelectionChange(USERLIST);
      } else {
        onSelectionChange(USERLIST.map(row => row.id));
      }
    }
  };

  const isAllSelected = enableSelection && returnRowOnSelection ? selectedRows.length === USERLIST.length && USERLIST.length > 0 : selectedRows.length === USERLIST.length && USERLIST.length > 0;

  return (
    <>
      <TableContainer className={classes.mainBox}>
        <Table>
          <TableHeader
            headLabel={TABLE_HEAD}
            rowCount={USERLIST?.length}
            enableSelection={enableSelection}
            isAllSelected={isAllSelected}
            onSelectAll={handleSelectAll}
          />
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={columnSpan} className={classes.content} align="center">
                  Loading...
                </TableCell>
              </TableRow>
            ) : USERLIST?.length > 0 ? USERLIST?.map((row, index) => {
              const { id } = row;
              const isSelected = enableSelection && returnRowOnSelection ? selectedRows.includes(row) : selectedRows.includes(id); // NEW: Add this
              const finalClass =
                index % 2 === 0
                  ? classes.box
                  : `${classes.box} ${classes.backgroundGrey}`;
              return (
                <TableRow
                  hover
                  key={id}
                  tabIndex={-1}
                  role="checkbox"
                  className={finalClass}
                  selected={isSelected} // NEW: Add this
                >
                  {/* NEW: Add selection checkbox column */}
                  {enableSelection && (
                    <TableCell
                      className={classes.content}
                      align="left"
                      padding="checkbox"
                    >
                      <Checkbox
                        checked={isSelected}
                        onChange={() => returnRowOnSelection ? handleRowSelection(row) : handleRowSelection(id)}
                        color="primary"
                      />
                    </TableCell>
                  )}

                  {TABLE_HEAD?.map((value, tindex) => {
                    const val = value.id;
                    const pageIndex = index;
                    if (tindex === 0) {
                      return (
                        <TableCell
                          key={value.id}
                          className={classes.content}
                          align="left"
                        >
                          {page * rowsPerPage + index + 1}
                        </TableCell>
                      );
                    }
                    if (value.clickable && val !== "actions") {
                      const { onCellClick } = value?.callback || {};
                      return (
                        <TableCell
                          key={value.id}
                          className={classes.contentLink}
                          align="left"
                          style={{ cursor: "pointer" }}
                          onClick={() => onCellClick && onCellClick(row)}
                        >
                          {formatCellValue(USERLIST[pageIndex][val], val)}
                        </TableCell>
                      );
                    }
                    if (
                      val === "status"
                    ) {
                      // Check if it's a campaign status (has statusInfo)
                      if (USERLIST[pageIndex].statusInfo) {
                        const statusInfo = USERLIST[pageIndex].statusInfo;
                        return (
                          <TableCell
                            key={value.id}
                            className={classes.content}
                            align="left"
                          >
                            <Chip
                              label={statusInfo.label}
                              style={{
                                backgroundColor: statusInfo.bgColor,
                                color: statusInfo.color,
                                fontWeight: 'bold',
                                fontSize: '12px'
                              }}
                              size="small"
                            />
                          </TableCell>
                        );
                      }

                      // Default status handling for other modules
                      return (
                        <TableCell
                          key={value.id}
                          className={classes.content}
                          align="left"
                        >
                          {USERLIST[pageIndex][val] || "-"}
                        </TableCell>
                      );
                    }
                    if (
                      val === "isActive" ||
                      val === "isPublished"
                    ) {
                      const {
                        handleStatusChange
                      } = value?.callback || "";
                      return (
                        <TableCell
                          key={value.id}
                          className={classes.content}
                          align="left"
                          value={USERLIST[pageIndex][val]}
                          onClick={() => handleStatusChange(row.id, val)}
                        >
                          <Switch status={USERLIST[pageIndex][val]} />
                        </TableCell>
                      );
                    }
                    if (val === "countryCode") {
                      return (
                        <TableCell
                          key={value.id}
                          className={classes.content}
                          align="left"
                        >{`${row?.countryCode} ${row?.mobile}`}</TableCell>
                      );
                    }
                    if (val === "title") {
                      const userlist = row.title;
                      return (
                        <TableCell
                          key={value.id}
                          className={classes.content}
                          align="left"
                        >
                          {userlist.length > 20 ? userlist.split(" ").slice(0, 2).join(" ") + "..." + userlist.split(" ").slice(-2).join(" ") : userlist}
                        </TableCell>
                      );
                    }
                    if (val === 'walletAddr') {
                      const wallet = getWalletValue(USERLIST[pageIndex]);
                      const isCopyEnabled = Boolean(USERLIST[pageIndex]?.copyWalletOnClick && wallet);
                      const walletPreview =
                        USERLIST[pageIndex] && wallet
                          ? `${wallet?.slice(0, 3)}...${wallet?.slice(-3)}`
                          : 'N/A';

                      return (
                        <TableCell
                          key={value.id}
                          className={classes.content}
                          align="left"
                          onClick={
                            isCopyEnabled
                              ? () => copyTextToClipboard(wallet, "Wallet address copied")
                              : undefined
                          }
                          style={isCopyEnabled ? { cursor: "pointer" } : undefined}
                          title={isCopyEnabled ? "Click to copy wallet address" : undefined}
                        >
                          {isCopyEnabled ? (
                            <span className={classes.copyableContent}>
                              <span>{walletPreview}</span>
                              <FileCopyOutlinedIcon className={classes.copyIndicator} />
                            </span>
                          ) : (
                            walletPreview
                          )}
                        </TableCell>
                      );
                    }

                    //projectlist
                    if (val === "projectName") {
                      const userlist = row.projectName;
                      return (
                        <TableCell
                          key={value.id}
                          className={classes.content}
                          align="left"
                        >
                          {userlist}
                        </TableCell>
                      );
                    }

                    if (val === "projectName1") {
                      const userlist = row.projectName1;
                      return (
                        <TableCell
                          key={value.id}
                          className={classes.content}
                          align="left"
                        >
                          {userlist}
                        </TableCell>
                      );
                    }

                    if (val === "projectName1") {
                      const userlist = row.projectName1;
                      return (
                        <TableCell
                          key={value.id}
                          className={classes.content}
                          align="left"
                        >
                          {userlist}
                        </TableCell>
                      );
                    }

                    if (val === "music") {
                      const userlist = row.music;
                      return (
                        <TableCell
                          key={value.id}
                          className={classes.content}
                          align="left"
                        >
                          {userlist}
                        </TableCell>
                      );
                    }

                    if (val === "mintedMusics") {
                      const userlist = row.minted_music;
                      return (
                        <TableCell
                          key={value.id}
                          className={classes.content}
                          align="left"
                        >
                          {userlist}
                        </TableCell>
                      );
                    }

                    if (val === "collaborators") {
                      const userlist = row.collaborations;
                      return (
                        <TableCell
                          key={value.id}
                          className={classes.content}
                          align="left"
                        >
                          {userlist && userlist.length > 0 ? userlist : "NA"}
                        </TableCell>
                      );
                    }

                    if (val === "createdBy") {
                      return (
                        <TableCell
                          key={value.id}
                          className={classes.content}
                          align="left"
                        >
                          {USERLIST[pageIndex] &&
                            USERLIST[pageIndex][val]?.fullName}
                        </TableCell>
                      );
                    }
                    if (val === "createdById") {
                      return (
                        <TableCell
                          key={value.id}
                          className={classes.content}
                          align="left"
                        >
                          {USERLIST[pageIndex] &&
                            USERLIST[pageIndex][val]?.fullName}
                        </TableCell>
                      );
                    }
                    if (val === "createdByUsername" || val === "currentOwner") {
                      const account = USERLIST[pageIndex][value.flag]?.wallet;
                      return (
                        <TableCell
                          key={value.id}
                          className={classes.content}
                          align="left"
                        >
                          <a
                            href={`${process.env.REACT_APP_FRONT_END_POINT_URL_DEV
                              }/artist-profile/${USERLIST[pageIndex][value.flag]?.id
                              }`}
                            target="_blank"
                            rel="noreferrer"
                            style={{
                              padding: 0,
                              textDecoration: "underline",
                              margin: 0,
                            }}
                          >
                            {account
                              ? `${account?.slice(0, 4)}...${account?.slice(
                                -4
                              )}`
                              : "----"}
                          </a>
                        </TableCell>
                      );
                    }
                    if (val === "isStatus") {
                      return (
                        <TableCell
                          key={value.id}
                          className={classes.content}
                          align="left"
                        >
                          {USERLIST[pageIndex] &&
                            USERLIST[pageIndex][value.flag]}
                        </TableCell>
                      );
                    }
                    if (val === "isPublishByAdmin") {
                      return (
                        <TableCell
                          key={value.id}
                          className={classes.content}
                          align="left"
                        >
                          {USERLIST[pageIndex] &&
                            USERLIST[pageIndex][value.flag] ? "Yes" : "No"}
                        </TableCell>
                      );
                    }
                    if (val === "createdAt") {
                      return (
                        <TableCell
                          key={value.id}
                          className={classes.content}
                          align="left"
                        >
                          {(USERLIST[pageIndex] &&
                            moment(USERLIST[pageIndex][val]).format(
                              "DD/MM/YYYY HH:mm"
                            )) ||
                            "Invalid Date"}
                        </TableCell>
                      );
                    }

                    if (val === "updatedAt") {
                      return (
                        <TableCell
                          key={value.id}
                          className={classes.content}
                          align="left"
                        >
                          {USERLIST[pageIndex] &&
                            moment(USERLIST[pageIndex][val]).format(
                              "MM/DD/YYYY HH:mm"
                            )}
                        </TableCell>
                      );
                    }
                    if (val === "roleCreatedBy") {
                      return (
                        <TableCell
                          key={value.id}
                          className={classes.content}
                          align="left"
                        >
                          {USERLIST[pageIndex] &&
                            moment(USERLIST[pageIndex]?.createdAt)
                              .local()
                              .format("MM/DD/YYYY HH:mm")}
                        </TableCell>
                      );
                    }
                    if (
                      value.flag === "adminRole" ||
                      value.flag === "collection"
                    ) {
                      return (
                        <TableCell
                          key={value.id}
                          className={classes.content}
                          align="left"
                        >
                          {USERLIST[pageIndex] && USERLIST[pageIndex][val]?.name
                            ? USERLIST[pageIndex][val]?.name
                            : "----"}
                        </TableCell>
                      );
                    }
                    if (value.flag === "viewCollectiblepaymentMethod") {
                      return (
                        <TableCell
                          key={value.id}
                          className={classes.content}
                          align="center"
                        >
                          {USERLIST[tindex][val]}
                        </TableCell>
                      );
                    }
                    if (
                      value.flag === "txnHash" ||
                      value.flag === "owner" ||
                      value.flag === "creator" ||
                      value.flag === "collectibleName"
                    ) {
                      const transactionHash = getTransactionHash(row);

                      return (
                        <TableCell
                          key={value.id}
                          className={
                            transactionHash ? classes.contentLink : classes.content
                          }
                          align="left"
                        >
                          <a
                            href={getTransactionUrl(transactionHash)}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {transactionHash ? formatHash(transactionHash) : "N/A"}
                          </a>
                        </TableCell>
                      );
                    }
                    if (value.flag === "txnHashValidate") {
                      const transactionHash = getTransactionHash(row);

                      return (
                        <TableCell
                          key={value.id}
                          className={
                            transactionHash ? classes.contentLink : classes.content
                          }
                          align="left"
                        >
                          <a
                            href={getTransactionUrl(transactionHash)}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {transactionHash ? formatHash(transactionHash) : "N/A"}
                          </a>
                        </TableCell>
                      );
                    }
                    if (value.flag === "tokenAmount") {
                      return (
                        <TableCell
                          key={value.id}
                          className={classes.content}
                          align="left"
                        >
                          {row?.token?.amount
                            ? `${row?.token?.amount} ${row?.token?.symbol}`
                            : "N/A"}
                          { }
                        </TableCell>
                      );
                    }
                    if (value.flag === "amount") {
                      return (
                        <TableCell
                          key={value.id}
                          className={classes.content}
                          align="left"
                        >
                          {row?.amount
                            ? `${row?.amount} ${row?.currency}`
                            : "N/A"}
                          { }
                        </TableCell>
                      );
                    }
                    if (value.flag === "variableType") {
                      return (
                        <TableCell
                          key={value.id}
                          className={classes.content}
                          align="left"
                        >
                          {row?.name === "Platform_Fee"
                            ? "Platform Fee"
                            : "Nominee Transfer"}
                          { }
                        </TableCell>
                      );
                    }
                    if (value.flag === "variableValue") {
                      return (
                        <TableCell
                          key={value.id}
                          className={classes.content}
                          align="left"
                        >
                          {row?.name === "Platform_Fee" ? (
                            `${data?.variables?.variables[0]?.value} USD`
                          ) : (
                            <div>
                              {`${data?.variables?.variables[1]?.name}: ${data?.variables?.variables[1]?.value}`}{" "}
                              Days, <br />
                              {`${data?.variables?.variables[2]?.name}: ${data?.variables?.variables[2]?.value}`}{" "}
                              Days, <br />
                              {`${data?.variables?.variables[3]?.name}: ${data?.variables?.variables[3]?.value}`}{" "}
                              Days, <br />
                              {`${data?.variables?.variables[4]?.name}: ${data?.variables?.variables[4]?.value}`}{" "}
                              Days, <br />
                              {`${data?.variables?.variables[5]?.name}: ${data?.variables?.variables[5]?.value}`}{" "}
                              Days, <br />
                            </div>
                          )}
                        </TableCell>
                      );
                    }

                    if (value.flag === "tokenIdWithLink") {
                      return (
                        <TableCell
                          key={value.id}
                          className={classes.content}
                          align="left"
                        >
                          <a
                            href="https://etherscan.io/address/0x9f7dd5ea934d188a599567ee104e97fa46cb4496#tokentxns"
                            target="_blank"
                            rel="noreferrer"
                            style={{
                              padding: 0,
                              textDecoration: "none",
                              margin: 0,
                            }}
                          >
                            {USERLIST[pageIndex][val]}{" "}
                          </a>
                        </TableCell>
                      );
                    }
                    if (value.flag === "domain") {
                      return (
                        <TableCell
                          key={value.id}
                          className={classes.content}
                          align="left"
                        >
                          <a
                            href={`https://${USERLIST[pageIndex][val]}.guildtogether.com`}
                            rel="noreferrer"
                            target="_blank"
                            style={{
                              padding: 0,
                              textDecoration: "none",
                              margin: 0,
                            }}
                          >
                            {USERLIST[pageIndex][val]}{" "}
                          </a>
                        </TableCell>
                      );
                    }
                    if (val === "actions") {
                      const { cancel } = value.flag || {};
                      const isCanceling = cancelingAirdropId === row.id;
                      // Cancel Airdrop (Airdrop Table only)
                      if (cancel) {
                        const { handleCancelAirdrop } = value.callback || {};
                        // Use onRequestCancelAirdrop if provided, else fallback to handleCancelAirdrop
                        const { onRequestCancelAirdrop } = typeof handleCancelAirdrop === 'object' ? handleCancelAirdrop : {};
                        const triggerCancel = onRequestCancelAirdrop || handleCancelAirdrop;
                        return (
                          <TableCell
                            key={value.id}
                            className={classes.content}
                            align="left"
                          >
                            {row.status === 'pending' && (
                              <Icon
                                style={{ color: 'red', cursor: isCanceling ? 'not-allowed' : 'pointer' }}
                                onClick={() => !isCanceling && triggerCancel(row.id)}
                                title="Cancel Airdrop"
                                disabled={isCanceling}
                              >
                                {isCanceling ? <CircularProgress size={20} color="inherit" /> : <CancelIcon />}
                              </Icon>
                            )}
                          </TableCell>
                        );
                      }

                      // UPDATED: Generic actions + Campaign actions + Campaign Delete + Revoke
                      const { read, edit, remove, add, start, pause, resume, campaignDelete, revoke } = value.flag || {};
                      const {
                        handleViewButton,
                        handleEditButton,
                        handleDeleteButton,
                        handleAddButton,
                        // Campaign action handlers
                        handleStartCampaign,
                        handlePauseCampaign,
                        handleResumeCampaign,
                        // Campaign delete handler
                        handleCampaignDelete,
                        // Revoke handler
                        handleRevokeButton,
                      } = value?.callback || {};

                      if (!read && !edit && !remove && !add && !start && !pause && !resume && !campaignDelete && !revoke) return <></>;

                      return (
                        <TableCell
                          key={value.id}
                          className={classes.content}
                          align="left"
                        >
                          {/* Campaign specific actions - conditional based on status */}
                          {start && handleStartCampaign && row.status === "Draft" && (
                            <Icon
                              onClick={() => handleStartCampaign(row)}
                              title="Start Campaign"
                              className={classes.iconRead}
                            >
                              <PlayArrowIcon />
                            </Icon>
                          )}

                          {pause && handlePauseCampaign && (row.status === "Active" || row.status === "Running Subsequences") && (
                            <Icon
                              onClick={() => handlePauseCampaign(row)}
                              title="Pause Campaign"
                              className={classes.iconRead}
                            >
                              <PauseIcon />
                            </Icon>
                          )}

                          {resume && handleResumeCampaign && row.status === "Paused" && (
                            <Icon
                              onClick={() => handleResumeCampaign(row)}
                              title="Resume Campaign"
                              className={classes.iconRead}
                            >
                              <PlayArrowIcon />
                            </Icon>
                          )}

                          {/* Standard read action - always available */}
                          {read && (
                            <Icon
                              onClick={() =>
                                value.alt === "data"
                                  ? handleViewButton(row)
                                  : handleViewButton(row._id ? row._id : row.id)
                              }
                            >
                              <img
                                alt="imageAlt"
                                className={classes.iconRead}
                                src={Read}
                              />
                            </Icon>
                          )}

                          {/* Standard edit action */}
                          {edit && (
                            <Icon
                              onClick={() =>
                                value.alt === "data"
                                  ? handleEditButton(row)
                                  : handleEditButton(row._id ? row._id : row.id || row.name)
                              }
                            >
                              <img
                                alt="imageAlt"
                                className={classes.iconEdit}
                                src={Edit}
                              />
                            </Icon>
                          )}

                          {/* Standard delete action - for non-campaign tables */}
                          {remove && !campaignDelete && (
                            <Icon
                              onClick={() =>
                                value.alt === "data"
                                  ? handleDeleteButton(row)
                                  : handleDeleteButton(row._id ? row._id : row.id)
                              }
                            >
                              <img
                                alt="imageAlt"
                                className={classes.iconDlt}
                                src={Delete}
                              />
                            </Icon>
                          )}

                          {/* Campaign-specific delete - conditional based on status */}
                          {campaignDelete && handleCampaignDelete && row.status !== "Completed" && (
                            <Icon
                              onClick={() => handleCampaignDelete(row)}
                              title="Delete Campaign"
                            >
                              <img
                                alt="imageAlt"
                                className={classes.iconDlt}
                                src={Delete}
                              />
                            </Icon>
                          )}
                          {/* Revoke action - conditional based on status */}
                          {revoke && handleRevokeButton && row.status !== "accepted" && (
                            <Icon
                              onClick={() =>
                                value.alt === "data"
                                  ? handleRevokeButton(row)
                                  : handleRevokeButton(row._id ? row._id : row.id)
                              }
                              title="Revoke Invitation"
                            >
                              <CancelIcon className={classes.iconDlt} />
                            </Icon>
                          )}
                          {add && (
                            <Icon
                              style={{ cursor: "pointer" }}
                              onClick={() => handleAddButton(row.id)}
                            >
                              <AddCircleIcon />
                            </Icon>
                          )}
                        </TableCell>
                      );
                    }
                    if (val === "nomineeStatus") {
                      const { read, edit, remove, add } = value.flag || "";
                      const {
                        handleViewButton,
                        handleEditButton,
                        handleDeleteButton,
                        handleAddButton,
                      } = value?.callback || "";
                      if (!read && !edit && !remove && !add) return <></>;
                      return (
                        <TableCell
                          key={value.id}
                          className={classes.content}
                          align="left"
                        >
                          {read && (
                            <Icon
                              onClick={() => {
                                value.alt === "data"
                                  ? handleViewButton(row)
                                  : handleViewButton(row._id ? row._id : row.id)
                              }
                              }
                            >
                              <img
                                alt="imageAlt"
                                className={classes.iconRead}
                                src={Read}
                              />
                            </Icon>
                          )}
                          {edit && (
                            <Icon
                              onClick={() => {
                                value.alt === "data"
                                  ? handleEditButton(row)
                                  : handleEditButton(row._id ? row._id : row.name)
                              }
                              }
                            >
                              <img
                                alt="imageAlt"
                                className={classes.iconEdit}
                                src={Edit}
                              />
                            </Icon>
                          )}
                          {remove && (
                            <Icon onClick={() => handleDeleteButton(row.id)}>
                              <img
                                alt="imageAlt"
                                className={classes.iconDelete}
                                src={Delete}
                              />
                            </Icon>
                          )}
                          {add && (
                            <Icon
                              style={{ cursor: "pointer" }}
                              onClick={() => handleAddButton(row.id)}
                            >
                              <AddCircleIcon />
                            </Icon>
                          )}
                        </TableCell>
                      );
                    }
                    return (
                      <TableCell
                        key={value.id}
                        className={classes.content}
                        // style={{ textTransform: "capitalize" }}
                        align="left"
                      >
                        {formatCellValue(USERLIST[pageIndex][val], val)}
                      </TableCell>
                    );
                  })}
                </TableRow>
              );
            }) : error ?
              <TableRow>
                <TableCell colSpan={columnSpan} className={classes.content} align="center" style={{ color: 'red' }}>
                {error.message === UNAUTHORIZED_ACCESS ? (
                  <>
                    <strong>🔒 Access Restricted</strong>
                    <br />
                    <br />
                    You don't have the necessary permissions to view this content. Please check your account privileges.
                  </>
                ) : error.message}
                </TableCell>
              </TableRow>
              : (
              <TableRow>
                <TableCell colSpan={columnSpan} className={classes.content} align="center">No Data Found</TableCell>
              </TableRow>
              )}
          </TableBody>
        </Table>
      </TableContainer>
      {!noPagination && (
        <Pagination
          currentPage={page}
          maxPage={maxPage}
          handlePrevPage={handlePreviousPage}
          handleNextPage={handleNextPage}
          pageInfo={pageInfo}
          onJumpToPage={jumpToPage}
        />
      )}
    </>
  );
}

export default MainTable;
